import { render, staticRenderFns } from "./DialogExportLogistics.vue?vue&type=template&id=ca2d8a0a&scoped=true"
import script from "./DialogExportLogistics.vue?vue&type=script&lang=js"
export * from "./DialogExportLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2d8a0a",
  null
  
)

export default component.exports